import React, {Component} from 'react';
import CustomerOrderTable from "../../Customer/CustomerOrderTable/CustomerOrderTable";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";

class AllOrdersCaller extends Component {

    render() {
        return (
            <div className="user-info-content user-info-content-responsive">
                <div className="user-info-div-resp-1 resp-customer-order">
                    <div className="title-1 text-align-left">
                        <FormattedMessage id="app.all-customers-order-caller.title"
                                          defaultMessage="All Orders for Customer"/>
                        {/*{this.props.match.params.userId}*/}
                    </div>
                    <CustomerOrderTable userId={this.props.match.params.userId}/>

                </div>


            </div>
        );
    }
}
export default AllOrdersCaller;



// WEBPACK FOOTER //
// ./src/components/Admin/AllCustomers/AllCustomersRow/AllOrdersCaller.js